// Angular
import { Injectable } from '@angular/core';

// Libraries
import { BehaviorSubject } from 'rxjs';

// Models
import { ChartSettingsModel } from '../components/custom-chart/models/custom-charts.model';
import { AppCleanup } from '../../../shared/models';

@Injectable()
export class CustomChartsService extends AppCleanup {
	public chartSettings: BehaviorSubject<ChartSettingsModel[]> = new BehaviorSubject<ChartSettingsModel[]>([]);

	constructor() {
		super();
	}

	updateChartSettings(settings: ChartSettingsModel) {
		let settingsArray: ChartSettingsModel[] = this.chartSettings.getValue();

		if (settingsArray.length > 0) {
			let index: number = settingsArray.findIndex((setting: ChartSettingsModel) => setting.jobId === settings.jobId);

			if (index === -1) {
				settingsArray.push(settings);
			} else {
				settingsArray.splice(index, 1, settings);
			}
		} else {
			settingsArray.push(settings);
		}

		this.chartSettings.next(settingsArray);
	}

	getUserChartSettingsByJobId(jobId: number): ChartSettingsModel {
		return this.chartSettings.getValue().find((item: ChartSettingsModel) => item.jobId === jobId);
	}
}
